module.exports = __webpack_public_path__ + "img/ddos.b390e946.png";